import posthog from 'posthog-js';
export const initializePostHog = () => {
    if (!REACT_APP_POSTHOG_KEY) {
        console.warn('PostHog API key not configured');
        return;
    }
    const apiHost = REACT_APP_POSTHOG_ENDPOINT || 'https://us.i.posthog.com';
    posthog.init(REACT_APP_POSTHOG_KEY, {
        api_host: apiHost,
        defaults: '2025-05-24',
        capture_pageview: 'history_change',
        capture_pageleave: 'if_capture_pageview',
        autocapture: true,
        person_profiles: 'identified_only',
    });
};
export { posthog };
